module.exports = __webpack_public_path__ + "static/media/MexicoCity.83f1662f.jpg";